import { CxpTaskIntegrationType, CxpTaskStatus } from './cxp-tasks.model';

export const CXP_TASK_STATUS_LABELS: Record<CxpTaskStatus, string> = {
  open: 'Open',
  completed: 'Completed',
};

export const CXP_TASK_CTA_LABELS: Record<string, string> = {
  DRAFT: 'Start',
  SENT: 'Start',
  IN_PROGRESS: 'Continue',
  IN_REVIEW: 'View',
  DONE: 'View',
};

/**
 * Display descriptor for the brand mark shown on external task rows
 * (`external-deliverable`, `external-client-request-list`). Signals to the
 * user that clicking will hand off to a third-party application.
 *
 * Logos are full-color, non-square brand lockups, so we render them with a
 * plain `<img>` (NOT `<aiwyn-icon>` — that wrapper forces a square box and
 * mangles wide marks). The `assetPath` is rooted at the `src/` directory so
 * Angular's asset pipeline picks them up at build time.
 *
 * To add a new integration:
 *   1. Drop the SVG in `src/assets/3rd-party-logos/`
 *   2. Add the integration type to `CxpTaskIntegrationType`
 *   3. Add an entry here keyed on the new type
 *   4. Update the relevant mapper to detect it
 */
export interface CxpTaskIntegrationIcon {
  /** Path to the logo SVG (e.g. `assets/3rd-party-logos/SafeSend.svg`). */
  assetPath: string;
  /** Used as accessible alt text and tooltip on the logo. */
  label: string;
}

export const CXP_TASK_INTEGRATION_ICONS: Record<CxpTaskIntegrationType, CxpTaskIntegrationIcon> = {
  safesend: { assetPath: 'assets/3rd-party-logos/SafeSend.svg', label: 'SafeSend' },
  fieldguide: { assetPath: 'assets/3rd-party-logos/FieldGuide.svg', label: 'FieldGuide' },
};
